export default "__VITE_ASSET__CORVdu0L__"